














import { Component, Vue } from 'vue-property-decorator'
import Nav from '@/components/navbar/index.vue'
import Calendar from '@/components/echarts/Calendar.vue'
import Timer from '@/components/timer/Timer.vue'

@Component({
  name: 'Record',
  components: {
    Nav,
    Calendar,
    Timer
  }
})
export default class extends Vue {

}
